var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { spacing } from "@rentiohq/web-theme";
import styled from "styled-components";
export var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 2px 0;\n"], ["\n  margin: 2px 0;\n"])));
export var ActivityContentWrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: ", " 0;\n"], ["\n  margin: ", " 0;\n"])), spacing());
var templateObject_1, templateObject_2;
